"use client";

import React, { useEffect } from "react";
import { ArrowRight, Lock, ExternalLink, Zap, Layers } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const examples = [{
  id: 1,
  title: "SparkClean St. Gallen",
  industry: "Cleaning Service Website\n",
  domain: "sparkcleanstgallen.\n\n",
  image: "https://pagemaker.my-pagemaker24.com/wp-content/uploads/2026/04/Cleaning-Service-scaled.png?v=09i44fugw4l",
  link: "https://proud-swift.my-pagemaker24.com/#"
}, {
  id: 2,
  title: "Vitality Fitness",
  industry: "Fitness Website",
  domain: "vitalityfitness.pagemaker\u00A0",
  image: "https://pagemaker.my-pagemaker24.com/wp-content/uploads/2026/04/screencapture-together-orca-my-pagemaker24-2026-04-03-13_23_31-scaled.png?v=9bwadfxpqw",
  link: "https://together-orca.my-pagemaker24.com/"
}, {
  id: 3,
  title: "Maria's Hair Salon",
  industry: "Hair Salon Website",
  domain: "mariahairsalon.pagemaker",
  image: "https://pagemaker.my-pagemaker24.com/wp-content/uploads/2026/04/Hair-Salo-scaled.png?v=co1azvw1u8q",
  link: "https://cheerful-gnu-1.my-pagemaker24.com/"
}, {
  id: 4,
  title: "Color Craft Bern",
  industry: "Moler Website",
  domain: "colorcraftbern.pagemaker",
  image: "https://pagemaker.my-pagemaker24.com/wp-content/uploads/2026/04/Moler-scaled.png?v=a6tiktpldx",
  link: "https://civil-seal.my-pagemaker24.com/"
}, {
  id: 5,
  title: "Vista Properties Lausanne",
  industry: "Real Estate Website",
  domain: "vistalausanne.pagemaker\n",
  image: "https://pagemaker.my-pagemaker24.com/wp-content/uploads/2026/04/Real-Estate-scaled.png?v=pyzxuisv23",
  link: "https://romantic-insect.my-pagemaker24.com/"
}, {
  id: 6,
  title: "Zurich's Resto",
  industry: "Restaurant Website",
  domain: "zurichresto.pagemaker\n",
  image: "https://pagemaker.my-pagemaker24.com/wp-content/uploads/2026/04/restaurant.png-scaled.jpg?v=j1jzzezydc",
  link: "https://closing-starfish.my-pagemaker24.com/"
}];
const plans = [{
  name: "Starter",
  icon: Zap,
  iconBg: "bg-orange-100",
  iconStroke: "text-orange-500",
  description: "Do-it-yourself mit KI-Builder. Website, Webshop, Google-Eintrag & mehr — alles möglich.",
  price: "CHF 24",
  period: "/ Monat",
  subPrice: "Oder CHF 240 / Jahr — 2 Monate geschenkt.",
  featured: false,
  badge: "",
  cta: "split",
  links: {
    monthly: "https://dashboard.pagemaker24.ch/checkout?product_id=255&period=monthly",
    yearly: "https://dashboard.pagemaker24.ch/checkout?product_id=255&period=yearly"
  },
  featureLabel: "Inklusive:",
  features: ["1 Website, Webshop oder Landing Page", "KI Website-Builder (DIY)", "Hosting auf Google Cloud", "SSL-Zertifikat inklusive", "Schweizer Support per E-Mail", "Jederzeit auf Pro upgraden möglich"]
}, {
  name: "Pro Website",
  icon: Layers,
  iconBg: "bg-orange-100",
  iconStroke: "text-[hsl(16,88%,54%)]",
  description: "Ein PAGEMAKER24-Experte erstellt deine Website — Texte & Bilder inklusive.",
  price: "CHF 72",
  period: "/ Monat",
  subPrice: "CHF 864 / Jahr · jährlich verrechnet.",
  featured: true,
  badge: "Beliebt",
  cta: "single",
  links: {
    monthly: "",
    yearly: "https://dashboard.pagemaker24.ch/checkout?product_id=517&period=yearly"
  },
  featureLabel: "Alles aus Starter, plus:",
  features: ["Website-Erstellung durch PAGEMAKER24-Experte", "Texte & Bilder inklusive", "5 Änderungen pro Jahr", "SEO-Grundsetup", "Jährliche Strategiebesprechung"]
}, {
  name: "Pro Webshop",
  icon: Layers,
  iconBg: "bg-orange-100",
  iconStroke: "text-orange-800",
  description: "Dein Experte baut einen vollständigen Webshop mit Zahlungsanbindung.",
  price: "CHF 144",
  period: "/ Monat",
  subPrice: "CHF 1'728 / Jahr · jährlich verrechnet.",
  featured: false,
  badge: "",
  cta: "single",
  links: {
    monthly: "",
    yearly: "https://dashboard.pagemaker24.ch/checkout?product_id=518&period=yearly"
  },
  featureLabel: "Alles aus Pro, plus:",
  features: ["Webshop-Erstellung (WooCommerce)", "Bis 50 Produkte einpflegen", "Zahlungsanbindung Stripe & Twint", "5 Änderungen pro Jahr", "SEO-Grundsetup for Products"]
}];
export default function InspirierendeKmuBeispiele() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    (window as any).validateAiInput2 = () => {
      const textarea = document.getElementById("ai-builder-input-2") as HTMLTextAreaElement;
      if (!textarea) return;
      const input = textarea.value.trim();
      const msg = document.getElementById("validation-msg-2");
      const wrapper = textarea.closest(".ai-builder-wrapper-2");
      if (input.length >= 10 && msg) {
        msg.style.display = "none";
      }
      if (input.length > 0) {
        wrapper?.classList.add("has-value-2");
      } else {
        wrapper?.classList.remove("has-value-2");
      }
    };
    (window as any).handleAiBuilderSubmit2 = () => {
      const textarea = document.getElementById("ai-builder-input-2") as HTMLTextAreaElement;
      if (!textarea) return;
      const input = textarea.value.trim();
      const msg = document.getElementById("validation-msg-2");
      const maxMsg = document.getElementById("max-length-msg-2");
      if (input.length < 10) {
        if (msg) msg.style.display = "block";
        if (maxMsg) maxMsg.style.display = "none";
        return;
      }
      if (textarea.value.length > 2000) {
        if (maxMsg) maxMsg.style.display = "block";
        if (msg) msg.style.display = "none";
        return;
      }
      const data = JSON.stringify({
        initial_description: input
      });
      const encoded = encodeURIComponent(data);
      window.location.href = "https://dashboard.pagemaker24.ch/setup-onboarding/v2-ai-website-building?prefilledAiData=" + encoded + "&builder=wvc";
    };
  }, []);
  return <section id="inspirierende-kmu-beispiele" className="w-full py-24 bg-secondary overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground mb-6">
            Das bauen unsere Kunden mit PAGEMAKER24
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Vom Restaurant über die Arztpraxis bis zur Boutique: echte Websites
            von echten KMU.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {examples.map((example, i) => <a key={example.id} href={example.link} target="_blank" rel="noopener noreferrer" data-index={i} className="group/card flex flex-col bg-background rounded-xl border border-border shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden no-underline">
              <div className="h-10 border-b border-border bg-muted/40 flex items-center px-4 relative shrink-0">
                <div className="flex gap-1.5 z-10">
                  <div className="w-2.5 h-2.5 rounded-full bg-border group-hover/card:bg-destructive/60 transition-colors duration-300" />
                  <div className="w-2.5 h-2.5 rounded-full bg-border group-hover/card:bg-primary/60 transition-colors duration-300" />
                  <div className="w-2.5 h-2.5 rounded-full bg-border group-hover/card:bg-green-500/60 transition-colors duration-300" />
                </div>
                <div className="absolute left-1/2 -translate-x-1/2 w-1/2 max-w-[220px] h-6 bg-background rounded-md border border-border flex items-center justify-center gap-1.5 px-2 opacity-70 group-hover/card:opacity-100 transition-opacity duration-300">
                  <Lock className="w-3 h-3 text-muted-foreground shrink-0" />
                  <span className="text-[10px] text-muted-foreground truncate font-medium">
                    {example.domain}
                  </span>
                </div>
              </div>

              <AspectRatio ratio={16 / 10} className="bg-muted overflow-hidden relative">
                <img src={example.image} alt={`Vorschau der Website für ${example.title}`} className="w-full h-full object-cover object-top transition-[object-position] duration-[5000ms] ease-in-out group-hover/card:object-bottom" />
                <div className="absolute inset-0 bg-foreground/5 opacity-0 group-hover/card:opacity-100 transition-opacity duration-300 pointer-events-none flex items-center justify-center">
                  <div className="bg-background/95 backdrop-blur-sm border border-border text-foreground px-4 py-2 rounded-full text-sm font-medium shadow-sm flex items-center gap-2 translate-y-4 group-hover/card:translate-y-0 transition-transform duration-300">
                    <ExternalLink className="w-4 h-4 text-primary" />
                    Projekt ansehen
                  </div>
                </div>
              </AspectRatio>

              <div className="p-5 flex flex-col gap-1 border-t border-border/50">
                <h3 className="font-semibold text-lg text-foreground line-clamp-1">
                  {example.title}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {example.industry}
                </p>
              </div>
            </a>)}
        </div>

        {/* AI Builder + Pricing */}
        <style>{`
          @property --ai2-angle { syntax: "<angle>"; inherits: true; initial-value: 0turn; }
          @keyframes ai2-spin { 100% { --ai2-angle: 2turn; } }
          .ai-builder-wrapper-2 {
            position: relative; width: 100%; max-width: 580px; margin: 0 auto;
            border-radius: 20px;
            box-shadow: 0 4px 8px 0 rgba(20,21,31,0.10), 0 2px 4px 0 rgba(20,21,31,0.06);
          }
          .ai-builder-wrapper-2::before {
            content: " "; position: absolute; inset: -1px;
            border: 1px solid transparent; border-radius: inherit;
            background-image: conic-gradient(from var(--ai2-angle), rgba(51,57,241,0.2) 68%, #3339F1 81%, #3339F1 94%, rgba(51,57,241,0.2) 100%);
            background-origin: border-box;
            mask: linear-gradient(#000,#000) content-box, linear-gradient(#000,#000);
            -webkit-mask: linear-gradient(#000,#000) content-box, linear-gradient(#000,#000);
            mask-clip: content-box, border-box; -webkit-mask-clip: content-box, border-box;
            mask-composite: exclude; -webkit-mask-composite: xor;
            animation: ai2-spin 8s linear infinite;
            pointer-events: none;
          }
          .ai-builder-wrapper-2:has(textarea:focus)::before,
          .ai-builder-wrapper-2.has-value-2::before {
            animation: none; background-image: none; background: #3339F1;
          }
          .ai-builder-textarea-2 {
            width: 100%; height: 120px; padding: 14px 100px 14px 14px;
            border: 1px solid transparent; border-radius: 20px;
            background: transparent; color: var(--color-foreground);
            font-size: 0.875rem; font-family: inherit; resize: none;
            box-sizing: border-box; outline: none;
          }
          .ai-builder-textarea-2::placeholder { color: var(--color-muted-foreground); }
          .ai2-submit-btn {
            position: absolute; bottom: 8px; right: 8px;
            padding: 7px 14px; border-radius: 32px;
            border: none; background: #3339F1; color: #fff;
            font-size: 12px; cursor: pointer; transition: opacity 0.3s;
          }
          .ai2-submit-btn:hover { opacity: 0.9; }
        `}</style>

        <div className="w-full py-8">
          {/* AI Builder mini */}
          <div className="text-center max-w-2xl mx-auto mb-10">
            <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-3">
              Direkt loslegen
            </h3>
            <p className="text-muted-foreground mb-6">
              Beschreiben Sie Ihre Idee und Ihre Website wird in Minuten erstellt.
            </p>
            <div className="ai-builder-wrapper-2">
              <textarea id="ai-builder-input-2" className="ai-builder-textarea-2" placeholder="z.B. Eine Website für mein Coiffeur-Geschäft in Zürich..." onInput={() => (window as any).validateAiInput2?.()} />
              <button className="ai2-submit-btn" onClick={() => (window as any).handleAiBuilderSubmit2?.()}>
                Website generieren
              </button>
              <p id="validation-msg-2" style={{
              position: "absolute",
              top: "100%",
              left: 0,
              fontSize: "0.75rem",
              color: "red",
              margin: "8px 0 0",
              display: "none"
            }}>
                Bitte mindestens 10 Zeichen eingeben.
              </p>
              <p id="max-length-msg-2" style={{
              position: "absolute",
              top: "100%",
              left: 0,
              fontSize: "0.75rem",
              color: "red",
              margin: "8px 0 0",
              display: "none"
            }}>
                Zeichenlimit erreicht.
              </p>
            </div>
          </div>

          {/* ── Anchor für Header-Nav "Preise" ── */}
          <div id="preise" className="scroll-mt-32" aria-hidden="true" />

          {/* Pricing Cards */}
          <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
            {plans.map(plan => <div key={plan.name} className={`relative flex flex-col rounded-xl bg-background p-6 ${plan.featured ? "border-2 border-blue-500 shadow-md" : "border border-border"}`}>
                {plan.badge && <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-50 text-blue-600 text-xs font-medium px-3 py-1 rounded-md">
                    {plan.badge}
                  </span>}

                <div className={`w-10 h-10 rounded-lg ${plan.iconBg} flex items-center justify-center mb-4`}>
                  <plan.icon className={`w-5 h-5 ${plan.iconStroke}`} />
                </div>

                <h3 className="text-lg font-semibold text-foreground">
                  {plan.name}
                </h3>
                <p className="text-sm text-muted-foreground mt-1 leading-relaxed">
                  {plan.description}
                </p>

                <div className="mt-4 mb-2">
                  <p className="flex items-baseline gap-1">
                    <span className="text-2xl font-semibold text-foreground">
                      {plan.price}
                    </span>
                    <span className="text-sm text-muted-foreground">
                      {plan.period}
                    </span>
                  </p>
                  <p className="text-xs text-muted-foreground mt-1">
                    {plan.subPrice}
                  </p>
                </div>

                <div className="mt-auto pt-4">
                  {plan.cta === "split" ? <div className="flex gap-2">
                      <a href={plan.links.monthly} className="flex-1 text-center py-2.5 text-sm font-medium rounded-md border border-border text-foreground hover:bg-muted/50 transition-colors">
                        Monatlich
                      </a>
                      <a href={plan.links.yearly} className="flex-1 text-center py-2.5 text-sm font-medium rounded-md border border-border bg-muted/40 text-foreground hover:bg-muted transition-colors">
                        Jährlich{" "}
                        <span className="text-xs text-green-600 font-medium">
                          -17%
                        </span>
                      </a>
                    </div> : <a href={plan.links.yearly} className={`group flex items-center justify-center w-full py-2.5 text-sm font-medium rounded-md transition-colors ${plan.featured ? "bg-foreground text-background hover:opacity-90" : "border border-border text-foreground hover:bg-muted/50"}`}>
                      Jetzt starten
                      <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                    </a>}
                </div>

                <div className="border-t border-border/50 mt-5 pt-4">
                  <p className="text-[11px] text-muted-foreground uppercase tracking-wide mb-3">
                    {plan.featureLabel}
                  </p>
                  <ul className="flex flex-col gap-2">
                    {plan.features.map((feature, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-muted-foreground">
                        <svg className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                        {feature}
                      </li>)}
                  </ul>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}